import { Controller } from "@hotwired/stimulus";
import { FrameElement } from "@hotwired/turbo/dist/types/elements";
import { refreshActiveOnboardingStepPosition } from "../../Features/Shared/Components/Onboarding/OnboardingController";
import { EventHandlerRegistration, registerGlobalEventHandlerEventName } from "../../scripts/BodyController";
import { formSubmittedEventName, formEditingCancelledEventName } from "../ViewOrEditForm/ViewOrEditFormController";

export default class TurboFrameController extends Controller {
    static targets = ["turboFrame"];

    static values = {
        reloadOnEvent: String
    }

    readonly turboFrameTarget!: FrameElement;

    readonly hasReloadOnEventValue!: boolean;
    readonly reloadOnEventValue!: string;

    connect() {
        this.attachFormEventListeners();

        if (this.hasReloadOnEventValue) {
            this.dispatch(registerGlobalEventHandlerEventName, {
                prefix: "",
                detail: new EventHandlerRegistration(this.reloadOnEventValue!, () => {
                    this.reload();
                })
            });
        }
        
        this.onTurboFrameLoadRefreshActiveOnboardingStepPosition();
    }

    attachFormEventListeners() {
        this.turboFrameTarget.addEventListener(formSubmittedEventName, this.onFormSubmitted.bind(this), {});
        this.turboFrameTarget.addEventListener(formEditingCancelledEventName, this.onFormEditingCancelled.bind(this), {});
    }

    onFormSubmitted() {
        this.reload();
    }

    onFormEditingCancelled() {
        this.reload();
    }

    reload() {
        this.turboFrameTarget.reload();
    }

    onTurboFrameLoadRefreshActiveOnboardingStepPosition() { // Turbo frames like Warnings and Tutorials might move the whole page
        this.dispatch(registerGlobalEventHandlerEventName, {
            prefix: "",
            detail: new EventHandlerRegistration("turbo:frame-load", () => {
                refreshActiveOnboardingStepPosition();
            })
        });
    }
}